import type { AddProtocolAction } from 'maplibre-gl';

// 1x1 fully transparent PNG.
const BLANK_TILE_PNG_BASE64 =
    'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNgYGBgAAAABQABeqhXUAAAAABJRU5ErkJggg==';

const createBlankTilePng = () => Uint8Array.from(atob(BLANK_TILE_PNG_BASE64), char => char.charCodeAt(0));

export function withBlankMissingTiles(loadTile: AddProtocolAction): AddProtocolAction {
    return async (requestParameters, abortController) => {
        const response = await loadTile(requestParameters, abortController);

        // pmtiles returns `data: null` for a raster tile missing from the archive, and MapLibre leaves
        // that tile loading forever, so the map never fires `load` (where the pins are added).
        if (response.data === null) {
            return { ...response, data: createBlankTilePng() };
        }

        return response;
    };
}
